import {
  Company,
  PoliciesLedgerRow,
  Retailer,
} from 'models/retailer-interface';

export interface InitialRetailersState {
  isLoading: boolean;
  currentPage: number;
  retailersData: Retailer[];
  retailerDetail: Retailer | null;
  count: number | null;
  sortingKey: string | null;
  sortingOrder: number | null;
  selectedRetailer: Retailer | null;
  companyDetails: Company | null;
  ledgerRows: PoliciesLedgerRow[];
  ledgerCount: number;
  isLedgerLoading: boolean;
}

const initialRetailersState: InitialRetailersState = {
  isLoading: false,
  currentPage: 1,
  retailersData: [],
  retailerDetail: null,
  count: null,
  sortingKey: null,
  sortingOrder: null,
  selectedRetailer: null,
  companyDetails: null,
  ledgerRows: [],
  ledgerCount: 0,
  isLedgerLoading: false,
};

export default initialRetailersState;
